module.exports = __webpack_public_path__ + "static/fowf-frank-color-0b5fcc4448b005f6128fe9de67a74944.jpg";